<template>
  <section>
  <div class="tabContentBx">
    <div class="tabContent">
      <div class="formInfo mgb">
        <v-form ref="formGroup">

          <dl class="infoCont" v-if="!isModify && parent">
            <dt class="formInfoTxt small">상위분류</dt>
            <dd class="formInfoArea">
              <v-col class="mgr" sm="3">
                {{ parent.groupName }}
              </v-col>
            </dd>
          </dl>

          <dl class="infoCont">

            <dt class="formInfoTxt small">분류 명</dt>
            <dd class="formInfoArea">
              <v-col class="mgr" sm="3">
                <v-text-field v-model="group.groupName" label="분류 명"
                              dense clearable outlined required
                              maxlength="50"
                              :rules="[() => !!group.groupName || '분류 명을 입력해주세요.']"/>
              </v-col>
            </dd>

            <dt class="formInfoTxt small">사용여부</dt>
            <dd class="formInfoArea">
              <v-col class="mgr" sm="3">
                <v-switch
                    v-model="group.activated"
                    flat
                    color="primary"
                    label="사용 여부"
                ></v-switch>
              </v-col>
            </dd>

          </dl>
          <dl class="infoCont">
            <dt class="formInfoTxt small">다중선택</dt>
            <dd class="formInfoArea">
              <v-col class="mgr" sm="3">
                <v-switch
                    v-model="group.multiple"
                    flat
                    color="primary"
                    :label="`허용 ${group.activated ? '' : '안함'}`"
                ></v-switch>
              </v-col>
            </dd>
          </dl>

          <dl class="infoCont">
            <dt class="formInfoTxt small">설명</dt>
            <dd class="formInfoArea">
              <v-col class="mgr">
                <editor-component
                    ref="groupContents"
                    :val="group.groupContents"
                    :uploaded="fileMeta"
                    @callback-upload="uploadImage"
                    label="상세 내용"/>
              </v-col>
            </dd>
          </dl>

        </v-form>
      </div>
    </div>
  </div>
  <div class="btnStyleBx">
    <div class="btnCommon justify-center">
      <v-btn class="vBtn" @click="saveGroup">
        <v-icon left>mdi mdi-playlist-plus</v-icon> {{isModify?"저장" : "추가"}}
      </v-btn>
      <v-btn class="vBtn" @click="resetGroup">
        <v-icon left>mdi mdi-close</v-icon> 취소
      </v-btn>
      <v-btn class="vBtn" @click="deleteGroup"  v-if="isModify && !group.default">
        <v-icon left>mdi mdi-playlist-remove</v-icon> 삭제
      </v-btn>
    </div>
  </div>
  </section>
</template>

<script>
import groupApi from "@/api/GroupApi";
import _ from "lodash";
import EditorComponent from "../component/EditorComponent";

export default {
  name: "GroupDetail",
  components: {
    'editor-component': EditorComponent,
  },
  props: {
    item: {
      type: Object,
      default: () => {return {};}
    },
    items: Array,
    modify: {
      type: Boolean,
      default: false
    },
    parent: Object
  },
  data: () => ({
    rules: {
      required: value => !!value || '필수 입력 항목입니다..'
    },
    categories: [],
    errorMessages: '',
    group:{},
    isModify: false,
    fileMeta: {},
  }),
  watch: {
    item: function (newVal) {
      this.$refs.formGroup.resetValidation();
      this.group = _.cloneDeep(newVal??{});
    },
    modify: function(nv) {
      this.isModify = nv;
    }
  },
  methods: {
    async saveGroup() {
      if(!await this.$refs.formGroup.validate())
        return;

      if(!this.group.parentId && !this.isModify)
        this.group.parentId = this.parent?.groupId;

      this.group.groupContents = this.$refs.groupContents.getValue();

      let c = await groupApi.save(this.group);

      this.group = c;
      this.group.childGroups = [];
      this.isModify = true;
      this.$emit('callback-saved', c);
    },
    resetGroup() {

      if(!this.isModify) {
        this.group = {};
        this.group.groupContents = '';
      } else {
        this.group = _.cloneDeep(this.item);
      }


      this.$refs.formGroup.resetValidation();

      // this.group = {};
      // this.chart = {};
    },
    deleteGroup() {
      console.log(this.group)
      if(this.group.childGroups?.length??0 !== 0) {
        alert("하위 분류가 존재합니다.");
        return false;
      }

      if (confirm("해당 분류를 삭제하시겠습니까?")) {
        groupApi.deleteGroup(this.group.groupId).then(() => {
          this.$refs.formGroup.resetValidation();
          this.$emit('callback-deleted');
          this.group = {};
        });
      }
    },
    uploadImage(f) {
      groupApi.uploadImage(f).then(res => {
        this.fileMeta = res;
      });
    }
  }

}
</script>

<style lang="scss" scoped>
@import 'src/assets/style/layout/variables';

.dashWrap {
  display: flex;
}

.dashRow {
  display: flex;
  flex-direction: column;
  flex: 0 0 29% 69%;

  &:first-child {
    margin-right: 2%;
  }
}

.tit {
  margin-top: 30px;
  margin-left: 5px;
  margin-bottom: 10px;
  font-size: 18px;
}

.dashBx {
  padding: 20px;
  border: 1px solid #e9e9e9;

  .state {
    padding-top: 37px;
    padding-bottom: 37px;
    cursor: pointer;
    color: #666;

    dt {
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 20px;

      em {
        margin-right: 5px;
        font-size: 50px;
        font-weight: bold;
        color: #333;
      }
    }

    dd {
      font-weight: 500;
    }
  }

  .deposit {
    display: flex;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      flex: 0 0 38%;

      &:nth-child(3) {
        flex: 0 0 24%;
      }

      .depositTit {
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 25px;
        background: #f6f6f6;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      }

      .depositNum {
        display: flex;
        padding-top: 50px;
        padding-right: 30px;

        p {
          margin-right: 50px;

          em {
            font-size: 40px;
            font-weight: bold;
          }
        }
      }
    }
  }

}

.h3Title {
  @include h3-title;
}
.tabContent{
  .formInfo {
    @include form-info;
  }
  .formInfoArea{
    &.align-normal{
      align-items: normal !important;
    };
  }
  .list{
    display: flex;
    width: 100% !important;
    img{
      width: 100%;
      height: auto;
    }
  }
  .wh300{
    width: 300px;
    padding: 0;
  }
}
</style>